<div class="main-container">
    <div class="inner-container">
         <div class="cp_heading_black_component_semibold"> {{'PAGE_NOT_FOUND.PAGE_NOT_FOUND_LABEL' | translate}} </div>
         <div class="cp_slabel_l"> {{'PAGE_NOT_FOUND.PAGE_NOT_FOUND_MESSAGE' | translate}}  </div>
    </div> 
 </div>